import ProductDetailsSection from './ProductDetailsSection';

export default ProductDetailsSection;
